/**
 * Shared utilities for value list modals (Create and Edit).
 * Contains constants, types, validation logic, and helper functions.
 */

import { CODE_REGEX, CODE_REGEX_ERROR } from '@utils/string';

// Shared type for option input in both Create and Edit modals
export interface OptionInput {
  code: string;
  name: string;
  isOriginal?: boolean; // Used by Edit modal to track existing options
}

// Constant error key for the single pending option input
export const PENDING_OPTION_ERROR_KEY = 'pending-option-name';

/**
 * Validates value list form data and returns an object of field errors.
 * Returns an empty object if validation passes.
 */
export const validateValueListForm = (
  name: string,
  options: OptionInput[],
): Record<string, string> => {
  const newErrors: Record<string, string> = {};

  if (!name.trim()) {
    newErrors.name = 'Name is required';
  }

  // Check for duplicate codes and format issues (defensive - options should already be unique)
  const seenCodes = new Set<string>();
  options.forEach((opt) => {
    if (seenCodes.has(opt.code)) {
      newErrors.options = 'Option codes must be unique';
    } else if (opt.code && !CODE_REGEX.test(opt.code)) {
      newErrors.options = CODE_REGEX_ERROR;
    }
    seenCodes.add(opt.code);
  });

  return newErrors;
};
